module.exports = __webpack_public_path__ + "img/spring-hill-logo.a896c0a7.jpg";